import { OmsReport } from "../../lusca-search-api/generated-src";
import { OmsFilterCondition, conditionOperators } from "./omsFilterEditing";
import { columnValueError } from "./omsReportFormatting";

export type OmsFilterIssue = {
  index: number;
  control: "Field" | "Condition" | "Value";
  message: string;
};

export function filterIssue(
  report: OmsReport,
  condition: OmsFilterCondition,
  index: number
): OmsFilterIssue | undefined {
  const problem = (control: OmsFilterIssue["control"], message: string) => ({
    index,
    control,
    message,
  });
  if (!condition.column) return problem("Field", "Choose a field.");
  if (!report.columns.includes(condition.column))
    return problem(
      "Field",
      `${condition.column} is not in this source report.`
    );
  if (!conditionOperators(report, condition).includes(condition.operator))
    return problem("Condition", "Choose a condition supported by this field.");
  const error =
    condition.valueNotice ||
    columnValueError(
      report.columnTypes?.[condition.column] || "string",
      condition.operator,
      condition.value,
      condition.values
    );
  return error ? problem("Value", error) : undefined;
}
